import React from 'react';
import {createRoot} from 'react-dom/client';
import AssociationBattleApp from './AssociationBattleApp';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const container = document.getElementById('js-association-battle')!;
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <AssociationBattleApp/>
    </QueryClientProvider>);